import { Aggregator } from 'angular-slickgrid';
import { AggregatorTotalsHandler } from 'src/app/types/@types/sl-v-types';
import { SLAggregator } from './slaggregator';

export class NoneAggregator extends SLAggregator {
	accumulate() {
		return;
	}
	storeResult(_groupTotals: any, _completeHandler?: AggregatorTotalsHandler) {
		return;
	}
}